import createFabricObject from './src/createFabricObject'

export default {
  createFabricObject
}
